import { render, staticRenderFns } from "./VTextArea.vue?vue&type=template&id=d6c76a92&scoped=true"
import script from "./VTextArea.vue?vue&type=script&lang=js"
export * from "./VTextArea.vue?vue&type=script&lang=js"
import style0 from "./VTextArea.vue?vue&type=style&index=0&id=d6c76a92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c76a92",
  null
  
)

export default component.exports